import React, { useState } from "react";
import Header from "../components/layout/Header";
import Sidebar from "../components/layout/Sidebar";
import DashboardOverview from "../features/dashboard/DashboardOverview";
import { Bell, Plus, Menu } from "lucide-react";

const Dashboard: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div className="dashboard-page-container">
      <Sidebar className={isSidebarOpen ? "open" : ""} />
      {isSidebarOpen && <div className="overlay" onClick={closeSidebar} />}
      <div className="main-content-wrapper">
        <Header
          onMenuClick={toggleSidebar}
          // rightActions={
          //   <div className="actions tooltip-wrapper">
          //     <button className="bell-btn" disabled>
          //       <Bell size={18} />
          //     </button>
          //     <span className="tooltip-text">Coming Soon</span>
          //   </div>
          // }
        />
        <main className="content-area">
          <DashboardOverview />
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
